import React from 'react';
import icon1 from '../../Assets/facebook.svg';
import icon2 from '../../Assets/instagram.svg';
import icon3 from '../../Assets/linkedIn.svg';
import icon4 from '../../Assets/skype.svg';
import './Footer.css'

const Footer = () => {
    return (
        <div style={{ backgroundColor: 'whiteSmoke' }}>
            <div className="container">
                <div className="mx-md-5">
                    <div className="row mt-0 p-md-5 p-0 d-flex align-items-center justify-content-between">
                        <div className="col-lg-4 col-md-3 col-6">
                            <h4 className="fw-bold py-2 footer-header">Contact Us</h4>
                            <p>+(91)9876543210</p>
                            <p>Gurugaon, India</p>
                            <p>hello@panchi.com</p>

                        </div>
                        <div className="col-lg-4 col-md-2 col-6">
                            <h4 className="fw-bold py-2 mt-md-0 mt-5 footer-header">Our Company</h4>
                            <div className="row">
                                <div className="col-md-6 col-6">
                                    <p>About Us</p>
                                    <p>Our Vision</p>
                                    <p>Services</p>

                                </div>
                                <div className="col-md-6 col-6">
                                    <p>Partners</p>
                                    <p>Carears</p>
                                    <p>Contact Us</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-3 ">
                            <h4 className=" fw-bold py-md-2 pt-0  footer-header">Address</h4>
                            <p>U-52/15, Phase-IV, Udyog Bihar,</p>
                            <p> Sector 18, Gurugram, Haryana 122010</p>
                            <h5>Follow Us</h5>
                            <div className="social-icons">
                                <img src={icon1} alt="" />
                                <img src={icon2} alt="" />
                                <img src={icon3} alt="" />
                                <img src={icon4} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className='text-center mt-2'>
                        <p><span className="text-secondary fw-bold">© 2022 All Rights Reserved by Panchi.</span></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;